// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"216":"a3d8bd91","325":"e3b71dbe","343":"c221ab43","381":"3f138919","679":"fd6c6b92"}[chunkId] + ".chunk.js";
};